import type { EntityType } from 'types/entityType';

export const DEBOUNCE_DEFAULT_TIME = 300;

export const ENTITY_PLURALS: Record<EntityType, string> = {
    application: 'applications',
    battery: 'batteries',
    boundary: 'boundaries',
    client: 'clients',
    drone: 'drones',
    farm: 'farms',
    field: 'fields',
    pilot: 'pilots',
    role: 'roles',
    scheduledPilot: 'scheduledPilots',
    user: 'users'
};

export const TEST_ID = 'multiSelectPanel';
